import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class FilterService {

    private filterSource = new BehaviorSubject('');
    filterTerm = this.filterSource.asObservable();

    constructor() { }

    changeMessage(filterTerm: string) {
        this.filterSource.next(filterTerm);
    }
}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/services/filter.service.ts